import React from 'react';
import { Avatar, Card, Col, Row } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { PAGE_URLS, PARENT_ROUTES } from '../../helpers/endpoints';
import { useHistory } from 'react-router-dom';

const reportTypeSortConfig = {
  DELAYED_COLLECTION_ON_TIME: {
    order: 1
  },
  DELAYED_BY_WAITING_FOR_COURIER: {
    order: 2
  },
  DELAYED_AND_WAITING_FOR_COLLECTION: {
    order: 3
  },
  DELAYED_ON_COURIER: {
    order: 4
  },
  DELAYED_APPROVAL: {
    order: 5
  },
  DELAYED_DELIVERY_AND_WAITING_FOR_DELIVERY: {
    order: 6
  },
  DELAYED_DELIVERY_FROM_STORE: {
    order: 7
  }
};

const StoreAndCourierOperationCard = ({ collectionAndDeliveryDelayData }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const renderCardFields = () => {
    const itemsPerRow = 2;

    const sortedData = [...collectionAndDeliveryDelayData].sort((a, b) => {
      return reportTypeSortConfig[a.reportType]?.order - reportTypeSortConfig[b.reportType]?.order;
    });

    const rows = [];
    for (let i = 0; i < sortedData.length; i += itemsPerRow) {
      const rowItems = sortedData.slice(i, i + itemsPerRow);
      const row = (
        <Row gutter={16} key={i}>
          {rowItems.map((field, index) => (
            <Col key={index} span={24 / itemsPerRow}>
              <Card
                key={index}
                size="small"
                style={{ marginBottom: 10 }}
                onClick={() => routeOrdersPendingActionPage(field.reportType)}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}>
                  <div>
                    <Avatar shape="square" size="large"
                            style={{ background: field?.color }}>
                      <span style={{ fontWeight: 'bold' }}>{field.size}</span>
                    </Avatar>
                    <span style={{ marginLeft: 10 }}>{field.label}</span>
                  </div>
                  <div>
                    <RightOutlined />
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      );

      rows.push(row);
    }

    return rows;
  };

  const routeOrdersPendingActionPage = (reportTypeEnum) => {
    history.push({
      pathname: `${PARENT_ROUTES.ORDER_MANAGEMENT}${PAGE_URLS.ORDERS_PENDING_ACTIONS}`,
      state: {
        reportType: reportTypeEnum
      }
    });
  };

  return (
    <>
      <Row>
        <Col span={12}>
          <h2>{t('storeOperations')}</h2>
        </Col>
        <Col span={12}>
          <h2 style={{ paddingLeft: 8 }}>{t('courierOperations')}</h2>
        </Col>
      </Row>
      {renderCardFields()}
    </>
  );
};

export default StoreAndCourierOperationCard;
